import { create } from 'zustand'

interface PageRefreshState {
  generations: Record<string, number>
  bump: (tabId: string) => void
}

/** In-memory only — bumps force KeepAlive to remount the current tab pane. */
export const usePageRefreshStore = create<PageRefreshState>((set) => ({
  generations: {},
  bump: (tabId) =>
    set((state) => ({
      generations: {
        ...state.generations,
        [tabId]: (state.generations[tabId] ?? 0) + 1,
      },
    })),
}))
